/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
  }
}

(function($){
  $(function(){
    $prevArrow = '<svg width="101" height="8" viewBox="0 0 101 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.646446 4.35355C0.451187 4.15829 0.451187 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53554 0.464466C4.7308 0.659728 4.7308 0.976311 4.53554 1.17157L1.70711 4L4.53554 6.82843C4.7308 7.02369 4.7308 7.34027 4.53554 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM101 4.5H1V3.5H101V4.5Z" fill="#2E2B27"/></svg>';
    $nextArrow = '<svg width="101" height="8" viewBox="0 0 101 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100.354 4.35355C100.549 4.15829 100.549 3.84171 100.354 3.64645L97.1716 0.464466C96.9763 0.269204 96.6597 0.269204 96.4645 0.464466C96.2692 0.659728 96.2692 0.976311 96.4645 1.17157L99.2929 4L96.4645 6.82843C96.2692 7.02369 96.2692 7.34027 96.4645 7.53553C96.6597 7.7308 96.9763 7.7308 97.1716 7.53553L100.354 4.35355ZM0 4.5H100V3.5H0V4.5Z" fill="#2E2B27"/></svg>';

    $prevArrow2 = '<svg width="14" height="32" viewBox="0 0 14 32" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_642_2545" fill="white"><path d="M13.5221 32C13.668 32 13.8118 31.897 13.9054 31.7026C14.0626 31.3754 14.0186 30.9131 13.8073 30.6693L1.26891 16.2363L13.8136 1.32419C14.0226 1.07557 14.0617 0.612321 13.901 0.288523C13.7403 -0.0342725 13.4409 -0.0960819 13.2317 0.153221L0.186437 15.6605C0.0677008 15.8016 -0.000883435 16.0204 8.59492e-06 16.2518C0.00134022 16.4833 0.072581 16.7003 0.19221 16.8387L13.2374 31.8537C13.3233 31.9519 13.4234 31.9996 13.5222 31.9996L13.5221 32Z"/></mask><path d="M13.5221 32C13.668 32 13.8118 31.897 13.9054 31.7026C14.0626 31.3754 14.0186 30.9131 13.8073 30.6693L1.26891 16.2363L13.8136 1.32419C14.0226 1.07557 14.0617 0.612321 13.901 0.288523C13.7403 -0.0342725 13.4409 -0.0960819 13.2317 0.153221L0.186437 15.6605C0.0677008 15.8016 -0.000883435 16.0204 8.59492e-06 16.2518C0.00134022 16.4833 0.072581 16.7003 0.19221 16.8387L13.2374 31.8537C13.3233 31.9519 13.4234 31.9996 13.5222 31.9996L13.5221 32Z" fill="#FDFAF4"/><path d="M13.5221 32L12.5309 31.8682L12.3804 33H13.5221V32ZM13.9054 31.7026L14.8063 32.1367L14.8069 32.1355L13.9054 31.7026ZM13.8073 30.6693L14.563 30.0144L14.5622 30.0135L13.8073 30.6693ZM1.26891 16.2363L0.503675 15.5926L-0.0466602 16.2468L0.513995 16.8921L1.26891 16.2363ZM13.8136 1.32419L14.5788 1.96794L14.5789 1.9678L13.8136 1.32419ZM13.901 0.288523L14.7968 -0.156002L14.7962 -0.157108L13.901 0.288523ZM13.2317 0.153221L13.9969 0.796967L13.9976 0.796161L13.2317 0.153221ZM0.186437 15.6605L0.951662 16.3043L0.951677 16.3042L0.186437 15.6605ZM8.59492e-06 16.2518L-0.999986 16.2557L-0.999975 16.2576L8.59492e-06 16.2518ZM0.19221 16.8387L-0.564312 17.4927L-0.562676 17.4946L0.19221 16.8387ZM13.2374 31.8537L12.4825 32.5095L12.4847 32.512L13.2374 31.8537ZM13.5222 31.9996L14.5135 32.1314L14.6639 30.9996H13.5222V31.9996ZM13.5221 33C14.1817 33 14.6108 32.5424 14.8063 32.1367L13.0046 31.2685C13.0128 31.2515 13.1542 31 13.5221 31V33ZM14.8069 32.1355C14.9759 31.7835 15.0223 31.3993 14.9901 31.0601C14.9585 30.7282 14.8409 30.335 14.563 30.0144L13.0516 31.3242C13.0147 31.2816 13.0016 31.2494 12.9989 31.2422C12.9958 31.2341 12.9978 31.2366 12.999 31.2492C13.0002 31.2614 12.9996 31.2734 12.9983 31.2818C12.9969 31.2905 12.9963 31.2858 13.004 31.2698L14.8069 32.1355ZM14.5622 30.0135L2.02383 15.5805L0.513995 16.8921L13.0524 31.3251L14.5622 30.0135ZM2.03415 16.8801L14.5788 1.96794L13.0483 0.68044L0.503675 15.5926L2.03415 16.8801ZM14.5789 1.9678C14.8508 1.64452 14.9643 1.25148 14.9924 0.918649C15.0211 0.57932 14.9708 0.194717 14.7968 -0.156001L13.0053 0.733047C12.9967 0.715899 12.9971 0.710115 12.9985 0.718377C12.9998 0.726212 13.0006 0.738029 12.9995 0.750447C12.9984 0.763245 12.9963 0.766481 12.999 0.759224C13.0013 0.752962 13.0133 0.722161 13.0482 0.680578L14.5789 1.9678ZM14.7962 -0.157108C14.6245 -0.502178 14.2951 -0.869583 13.7839 -0.973587C13.234 -1.08548 12.7566 -0.83615 12.4657 -0.489719L13.9976 0.796161C13.916 0.893289 13.6929 1.04887 13.3852 0.986257C13.1162 0.931531 13.0169 0.756428 13.0058 0.734154L14.7962 -0.157108ZM12.4664 -0.490524L-0.578803 15.0167L0.951677 16.3042L13.9969 0.796966L12.4664 -0.490524ZM-0.578787 15.0167C-0.886844 15.3829 -1.00154 15.8517 -0.999984 16.2557L1 16.248C0.999932 16.23 1.0029 16.2204 1.00222 16.2226C1.00166 16.2243 0.999052 16.2322 0.992255 16.2452C0.985537 16.2579 0.973007 16.2789 0.951662 16.3043L-0.578787 15.0167ZM-0.999975 16.2576C-0.997641 16.6632 -0.877005 17.1309 -0.56431 17.4927L0.948729 16.1847C0.970901 16.2104 0.984048 16.2317 0.99118 16.2449C0.998398 16.2582 1.0013 16.2665 1.00202 16.2687C1.00304 16.2718 1.00009 16.2632 0.999992 16.2461L-0.999975 16.2576ZM-0.562676 17.4946L12.4826 32.5095L13.9923 31.1978L0.947096 16.1828L-0.562676 17.4946ZM12.4847 32.512C12.7201 32.7811 13.0788 32.9996 13.5222 32.9996V30.9996C13.7681 30.9996 13.9266 31.1227 13.9902 31.1954L12.4847 32.512ZM12.5309 31.8679L12.5309 31.8682L14.5134 32.1318L14.5135 32.1314L12.5309 31.8679Z" fill="#FDFAF4" mask="url(#path-1-inside-1_642_2545)"/></svg>';
    $nextArrow2 = '<svg width="14" height="32" viewBox="0 0 14 32" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_642_2554" fill="white"><path d="M0.477864 32C0.332048 32 0.188227 31.897 0.0945696 31.7026C-0.0625641 31.3754 -0.018622 30.9131 0.19267 30.6693L12.7311 16.2363L0.186421 1.32419C-0.0226495 1.07557 -0.061711 0.612321 0.0989737 0.288523C0.259658 -0.0342725 0.559061 -0.0960819 0.768336 0.153221L13.8136 15.6605C13.9323 15.8016 14.0009 16.0204 14 16.2518C13.9987 16.4833 13.9274 16.7003 13.8078 16.8387L0.762563 31.8537C0.676673 31.9519 0.576579 31.9996 0.477813 31.9996L0.477864 32Z"/></mask><path d="M0.477864 32C0.332048 32 0.188227 31.897 0.0945696 31.7026C-0.0625641 31.3754 -0.018622 30.9131 0.19267 30.6693L12.7311 16.2363L0.186421 1.32419C-0.0226495 1.07557 -0.061711 0.612321 0.0989737 0.288523C0.259658 -0.0342725 0.559061 -0.0960819 0.768336 0.153221L13.8136 15.6605C13.9323 15.8016 14.0009 16.0204 14 16.2518C13.9987 16.4833 13.9274 16.7003 13.8078 16.8387L0.762563 31.8537C0.676673 31.9519 0.576579 31.9996 0.477813 31.9996L0.477864 32Z" fill="#FDFAF4"/><path d="M0.477863 32L1.46914 31.8682L1.61959 33H0.477863V32ZM0.0945692 31.7026L-0.806293 32.1367L-0.806902 32.1355L0.0945692 31.7026ZM0.19267 30.6693L-0.563046 30.0144L-0.562247 30.0135L0.19267 30.6693ZM12.7311 16.2363L13.4963 15.5926L14.0467 16.2468L13.486 16.8921L12.7311 16.2363ZM0.18642 1.32419L-0.578817 1.96794L-0.578933 1.9678L0.18642 1.32419ZM0.0989733 0.288523L-0.796794 -0.156002L-0.796243 -0.157108L0.0989733 0.288523ZM0.768335 0.153221L0.00309563 0.796967L0.00241947 0.796161L0.768335 0.153221ZM13.8136 15.6605L13.0483 16.3043L13.0483 16.3042L13.8136 15.6605ZM14 16.2518L15 16.2557L15 16.2576L14 16.2518ZM13.8078 16.8387L14.5643 17.4927L14.5627 17.4946L13.8078 16.8387ZM0.762564 31.8537L1.51745 32.5095L1.51531 32.512L0.762564 31.8537ZM0.477814 31.9996L-0.513467 32.1314L-0.663913 30.9996H0.477814V31.9996ZM0.477863 33C-0.181685 33 -0.610789 32.5424 -0.806293 32.1367L0.995432 31.2685C0.987243 31.2515 0.845781 31 0.477863 31V33ZM-0.806902 32.1355C-0.975874 31.7835 -1.02227 31.3993 -0.99006 31.0601C-0.958529 30.7282 -0.840854 30.335 -0.563046 30.0144L0.948384 31.3242C0.985348 31.2816 0.998407 31.2494 1.00112 31.2422C1.00422 31.2341 1.00218 31.2366 1.00098 31.2492C0.999823 31.2614 1.00039 31.2734 1.00171 31.2818C1.00309 31.2905 1.00372 31.2858 0.996041 31.2698L-0.806902 32.1355ZM-0.562247 30.0135L11.9762 15.5805L13.486 16.8921L0.947587 31.3251L-0.562247 30.0135ZM11.9658 16.8801L-0.578817 1.96794L0.951658 0.68044L13.4963 15.5926L11.9658 16.8801ZM-0.578933 1.9678C-0.850788 1.64452 -0.964328 1.25148 -0.992418 0.918649C-1.02106 0.57932 -0.970837 0.194717 -0.796793 -0.156001L0.99474 0.733047C1.00325 0.715899 1.0029 0.710115 1.00151 0.718377C1.00019 0.726212 0.999448 0.738029 1.0005 0.750447C1.00158 0.763245 1.00366 0.766481 1.00101 0.759224C0.998713 0.752962 0.986743 0.722161 0.951775 0.680578L-0.578933 1.9678ZM-0.796243 -0.157108C-0.624471 -0.502178 -0.295108 -0.869583 0.216052 -0.973587C0.765994 -1.08548 1.24344 -0.83615 1.53425 -0.489719L0.00241947 0.796161C0.083952 0.893289 0.307064 1.04887 0.614815 0.986257C0.883783 0.931531 0.983103 0.756428 0.99419 0.734154L-0.796243 -0.157108ZM1.53358 -0.490524L14.5788 15.0167L13.0483 16.3042L0.00309563 0.796966L1.53358 -0.490524ZM14.5788 15.0167C14.8868 15.3829 15.0015 15.8517 15 16.2557L13 16.248C13.0001 16.23 12.9971 16.2204 12.9978 16.2226C12.9983 16.2243 13.0009 16.2322 13.0077 16.2452C13.0145 16.2579 13.027 16.2789 13.0483 16.3043L14.5788 15.0167ZM15 16.2576C14.9976 16.6632 14.877 17.1309 14.5643 17.4927L13.0513 16.1847C13.0291 16.2104 13.016 16.2317 13.0088 16.2449C13.0016 16.2582 12.9987 16.2665 12.998 16.2687C12.997 16.2718 12.9999 16.2632 13 16.2461L15 16.2576ZM14.5627 17.4946L1.51745 32.5095L0.00767708 31.1978L13.0529 16.1828L14.5627 17.4946ZM1.51531 32.512C1.27994 32.7811 0.921216 32.9996 0.477814 32.9996V30.9996C0.231941 30.9996 0.0734043 31.1227 0.00981331 31.1954L1.51531 32.512ZM1.46909 31.8679L1.46914 31.8682L-0.513416 32.1318L-0.513467 32.1314L1.46909 31.8679Z" fill="#FDFAF4" mask="url(#path-1-inside-1_642_2554)"/></svg>';
    
    function accordionOpenClose(){
      $('.lohobride-accordion-item:not(.active) .lohobride-accordion-item-content').slideUp();
      $('.lohobride-accordion-item.active .lohobride-accordion-item-content').slideDown();
    }

    function galleryAccordionOpenClose(){
      $('.loho-press-gallery-accordion-item-header:not(.active) .loho-press-gallery-accordion-item-gallery').slideUp();
      $('.loho-press-gallery-accordion-item-header.active .loho-press-gallery-accordion-item-gallery').slideDown();
    }

    if( $('.appointment-instagram-images-wrapper').length !== 0 ){
      $('.appointment-instagram-images-wrapper').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        draggable: true,
        infinite: true,
        variableWidth: true,
        centerMode: true
      });
    }
    

    if( $('.lohobride-accordion-wrapper').length !== 0 ){
      $('.lohobride-accordion-item-header-toggle').on('click', function(){
        $('.lohobride-accordion-item-header-toggle').not( $(this) ).closest('.lohobride-accordion-item').removeClass('active');
        $(this).closest('.lohobride-accordion-item').toggleClass('active');

        accordionOpenClose();
      });

      accordionOpenClose();
    }

    if( $('.loho-press-gallery-accordion-item-header').length !== 0 ){
      galleryAccordionOpenClose();

      $('.loho-press-gallery-accordion-item-header > div:first-child').on('click', function(){
        $('.loho-press-gallery-accordion-item-header > div:first-child').not( $(this) ).closest('.loho-press-gallery-accordion-item-header').removeClass('active');
        $(this).closest('.loho-press-gallery-accordion-item-header').toggleClass('active');

        galleryAccordionOpenClose();
      });
    }

    if( $('.loho-bridal-collections-slides-main').length !== 0 ){
      var $status = $('.loho-bridal-slides-count');
      var $slickElement = $('.loho-bridal-collections-slides-main');

      $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        if(!slick.$dots){
        	return;
        }

        var $slickTotal = slick.$dots[0].children.length < 10 ? '0' + slick.$dots[0].children.length : slick.$dots[0].children.length; 
        
        var i = (currentSlide ? currentSlide : 0) + 1;
        var i = i < 10 ? '0' + i : i;
        
        $status.html(i + '/<i>' + $slickTotal + '</i>');
      });
      
      $slickElement.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        fade: false,
        infinite: true,
        centerMode: false,
        prevArrow: '<button type="button" class="slick-prev"><span>'+ $prevArrow +'</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span>'+ $nextArrow +'</span></button>',
          responsive: [
        {
          breakpoint: 9999,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
      });
    }


    if( $('.loho-banner-images-wrapper').length !== 0 ){
        // $('.loho-banner-images-wrapper').slick({
        //   fade: true,
        //   slidesToShow: 1,
        //   slidesToScroll: 1,
        //   dots: false,
        //   arrows: false,
        //   infinite: true,
        //   autoplay: true,
        //   autoplaySpeed: 7000,
        //   pauseOnHover: false,
        //   pauseOnFocus: false,
        //   speed: 1000,
        //   draggable: false
        // });

      $('.loho-banner-images-wrapper').flickity({
          "prevNextButtons": false,
          "setGallerySize": false,
          "adaptiveHeight": false,
          "wrapAround": true,
          "dragThreshold": 15,
          "pauseAutoPlayOnHover": false,
          "autoPlay": 5000,
          "pageDots": false
        });
    }


    if( $('.loho-stylist-shop-item-medias').length !== 0 ){
        $('.loho-stylist-shop-item-medias').slick({
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          prevArrow: '<button type="button" class="slick-prev"><span>'+ $prevArrow2 +'</span></button>',
          nextArrow: '<button type="button" class="slick-next"><span>'+ $nextArrow2 +'</span></button>',
          draggable: false
        });
    }

    if( $('.loho-individual-product-item-medias').length !== 0 ){
        $('.loho-individual-product-item-medias').slick({
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          prevArrow: '<button type="button" class="slick-prev"><span>'+ $prevArrow2 +'</span></button>',
          nextArrow: '<button type="button" class="slick-next"><span>'+ $nextArrow2 +'</span></button>',
          draggable: false
        });
    }

    if( $('.loho-stylist-shop-main').length !== 0 ){
        $('.loho-stylist-shop-main').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          prevArrow: '<button type="button" class="slick-prev"><span>'+ $prevArrow +'</span></button>',
          nextArrow: '<button type="button" class="slick-next"><span>'+ $nextArrow +'</span></button>',
          draggable: false,
          responsive: [
        {
          breakpoint: 9999,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
          }
        }
      ]
        });
    }


    if( $('.loho-as-seen-wrapper').length !== 0 ){
        $('.loho-as-seen-wrapper').slick({
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          infinite: true,
          draggable: false,
          autoplay: true,
          autoplaySpeed: 7000,
          pauseOnHover: false,
          pauseOnFocus: false,
          speed: 1000,
          adaptiveHeight: true
        });
    }

    if( $('.loho-explore-events-slides-main').length !== 0 ){
      var $status = $('.loho-explore-events-count');
      var $slickElement = $('.loho-explore-events-slides-main');

      $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        if(!slick.$dots){
        	return;
        }

        var $slickTotal = slick.$dots[0].children.length < 10 ? '0' + slick.$dots[0].children.length : slick.$dots[0].children.length; 
        
        var i = (currentSlide ? currentSlide : 0) + 1;
        var i = i < 10 ? '0' + i : i;
        
        $status.html(i + '/<i>' + $slickTotal + '</i>');
      });
      
      $slickElement.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        fade: false,
        infinite: true,
        centerMode: false,
        prevArrow: '<button type="button" class="slick-prev"><span>'+ $prevArrow +'</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span>'+ $nextArrow +'</span></button>',
        responsive: [
        {
          breakpoint: 9999,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
      });
    }

    $(document).on('load scroll', function(){
      if( $('body').hasClass('template-index') || $('body').hasClass('custom-page-contact') || $('.loho-contact-us-page').length !== 0 ){
          $scrollTopOffet = $(window).scrollTop();

          $('header#section-header').toggleClass('header-scrolled-home', $scrollTopOffet > $(window).height() );
      }
    });


    if( $('.custom-play-trigger').length !== 0 ){
      var iframe = document.querySelector('.custom-feat-video-section .custom-modal iframe');
      var player = new Vimeo.Player( $('.custom-feat-video-section .custom-modal iframe') );

      $('.custom-play-trigger button').on('click', function(){
          $(this).closest('.custom-feat-video-section').find('.custom-modal').toggleClass('active');
          player.play();
      });
    }

    if( $('.js-transfer-about').length !== 0 ){
        $('nav.Header__MainNav ul.HorizontalList > li:last-child').prependTo('.js-transfer-about');

        $('.Header__SecondaryNav .HorizontalList__Item').hover(function(){
            $('.DropdownMenu', this).attr('aria-hidden', false);
        }, function(){
            $('.DropdownMenu', this).attr('aria-hidden', true);
        });
    }
  
    var OSName="Unknown OS";
    if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
    if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
    if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
    if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";

    $('body').addClass( OSName );
  });
})(jQuery);